import { createSelector } from 'reselect';
import get from 'lodash/get';
import { adContentFilteredMetrics } from '@store/common/selectors';
import { OVERVIEW_AUDIENCE_METRICS } from '@src/utils/kpi';
import { SCOPE } from './types';
import { formatResponse } from './helper';
import { filterColorSelector } from '../base/selectors';

const selector = (state) => get(state, SCOPE);

export const audienceMetricsSelector = createSelector(adContentFilteredMetrics, (baseMetrics) => {
  return OVERVIEW_AUDIENCE_METRICS.filter((m) => m in baseMetrics);
});

export const loadingSelector = createSelector(selector, (configState) => ({
  loading: configState.isFetching,
  showError: configState.errorCode !== 0 || configState.errorMsg,
  errorMsg: configState.errorMsg,
}));

export const audienceMetricDataSelector = createSelector(
  selector,
  filterColorSelector,
  audienceMetricsSelector,
  (audienceMetricData, filterColor, audienceMetrics) => {
    return formatResponse(audienceMetricData, filterColor, audienceMetrics);
  },
);

export default selector;
